import React, { useId } from 'react';
import { Path } from 'react-native-svg';
import { IconWithGradient } from 'design-system/icons/Icon';
export const IconShareSquare = ({ ...props }) => {
    const id = useId();
    return (<IconWithGradient id={id} defaultGradientKey="skyBlue" {...props}>
      <Path fillRule="evenodd" clipRule="evenodd" d="M20.924 4.117a.997.997 0 0 0-.215-.322l-.004-.004A.997.997 0 0 0 20 3.5h-6a1 1 0 1 0 0 2h3.586l-7.293 7.293a1 1 0 1 0 1.414 1.414L19 6.914V10.5a1 1 0 0 0 2 0V4.497a.999.999 0 0 0-.076-.38ZM3 8.5a5 5 0 0 1 5-5h1a1 1 0 0 1 0 2H8a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-1a1 1 0 0 1 2 0v1a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5v-8Z" fill={`url(#gradient_${id})`}/>
    </IconWithGradient>);
};
